function platformCreationPage(token) {
  const path = '/createteam';
  return token ? `${path}?token=${token}` : path;
}

export default {
  platformCreationPage
};
